import { render, staticRenderFns } from "./serviceContent.vue?vue&type=template&id=4a621bf2&"
import script from "./serviceContent.vue?vue&type=script&lang=js&"
export * from "./serviceContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports